import React, { useState, useEffect, useRef } from "react";
import Select, { components } from "react-select";
import styles from "./MultiSelectWithCheckbox.module.css";

const CheckboxOption = (props) => {
  const { data, isSelected, innerRef, innerProps, isFocused } = props;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`${styles.multiSelectOptionWrapper} ${
        isFocused ? styles.focusedOption : ""
      }`}
      role="option"
      aria-selected={isSelected}
    >
      <input
        type="checkbox"
        checked={isSelected}
        readOnly
        tabIndex={-1}
        className={styles.multiSelectCheckbox}
        aria-label={data.label}
      />
      {data.label}
    </div>
  );
};

const CustomValueContainer = (props) => {
  const { getValue, hasValue, children } = props;
  const selected = getValue();

  return (
    <components.ValueContainer {...props}>
      {hasValue && selected.length > 1 ? (
        <div className="h-100 d-flex align-items-center">
          {selected.length} selected
        </div>
      ) : (
        children
      )}
    </components.ValueContainer>
  );
};

const MultiSelectWithCheckbox = ({
  options,
  value,
  onChange,
  placeholder = "Select...",
  className = "",
  classNamePrefix = "select",
  customStyles = {},
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setMenuIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={wrapperRef} className={styles.wrapper}>
      <Select
        options={options}
        value={value}
        onChange={onChange}
        isMulti
        placeholder={placeholder}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isClearable={false}
        className={className}
        classNamePrefix={classNamePrefix}
        tabSelectsValue={false}
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        components={{
          Option: CheckboxOption,
          ValueContainer: CustomValueContainer,
        }}
        styles={{
          container: (provided) => ({
            ...provided,
            width: "100%",
            zIndex: 2,
            ...customStyles.container,
          }),
          control: (provided) => ({
            ...provided,
            minHeight: "40px",
            height: "40px",
            borderRadius: "6px",
            borderColor: "#ccc",
            boxShadow: "none",
            "&:hover": {
              borderColor: "#aaa",
            },
            ...customStyles.control,
          }),
          valueContainer: (provided) => ({
            ...provided,
            padding: "0 8px",
            height: "100%",
            alignItems: "baseline",
          }),
          ...customStyles,
        }}
      />
    </div>
  );
};

export default MultiSelectWithCheckbox;
